// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

var cardSlider = new Swiper('.slider_scroll_team__two', {
  slidesPerView: 1.2,
  spaceBetween: 20,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1260: {
      slidesPerView: 2,
    }
  }
});

var cardSlider = new Swiper('.slider_scroll_team', {
  slidesPerView: 1.2,
  spaceBetween: 20,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1260: {
      slidesPerView: 2,
    }
  }
});

var cardSlider = new Swiper('.slider_scroll_neighbourhood', {
  slidesPerView: 1.2,
  spaceBetween: 20,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 1.2,
    },
    1260: {
      slidesPerView: 1.8,
    }
  }
});